gsap.registerPlugin(ScrollTrigger)

document.addEventListener('DOMContentLoaded', () => {
  const heroAnimation = () => {
    let mm = gsap.matchMedia()
    const tabletBreakPoint = 1080
    const smallTabletBreakPoint = 766
    const mobileBreakPoint = 650

    mm.add(
      {
        // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
        isDesktop: `(min-width: ${tabletBreakPoint}px)`,
        isTablet: `(max-width: ${
          tabletBreakPoint - 1
        }px) and (min-width: ${smallTabletBreakPoint}px)`,
        isSmallTablet: `(max-width: ${
          smallTabletBreakPoint - 1
        }px) and (min-width: ${mobileBreakPoint}px)`,
        isMobile: `(max-width: ${mobileBreakPoint - 1}px)`,
        reduceMotion: '(prefers-reduced-motion: reduce)',
      },
      (context) => {
        // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
        let { isDesktop, isMobile, isSmallTablet, isTablet, reduceMotion } =
          context.conditions

        const hero_formulations = gsap
          .timeline({
            scrollTrigger: {
              trigger: '.hero__formulations',
              start: '50% 50%',
              end: '+1500px bottom',
              scrub: 1,
              pin: true,
              pinSpacing: true,
            },
          })
          .to(
            '.hero__formulation-ashwagandha',
            {
              x: () => {
                if (isSmallTablet || isMobile) {
                  return -(window.innerWidth / 8)
                } else {
                  return -140
                }
              },
            },
            0
          )
          .to(
            '.hero__formulation-passiflora',
            {
              x: () => {
                if (isSmallTablet || isMobile) {
                  return window.innerWidth / 8
                } else {
                  return 140
                }
              },
            },
            0
          )
          .to('.hero__formulation-text', { opacity: 1 }, 0.15)

        if (isDesktop) {
          const hero_illustrations = gsap.timeline({
            scrollTrigger: {
              trigger: '.hero__illustrations',
              start: 'top top',
              end: '+1965px bottom',
              scrub: 1,
              pin: true,
            },
          })
        }
      }
    )
  }

  const factsAnimation = () => {
    const facts__tl = gsap
      .timeline({
        scrollTrigger: {
          trigger: '.facts',
          start: 'bottom bottom',
          end: () => {
            return `2000px bottom,`
          },
          scrub: 1,
          pin: true,
          pinSpacing: true,
        },
      })
      .to('.fact1', { clipPath: 'inset(0% 0% 100% 0%)' })
      .to('.fact2', { clipPath: 'inset(0% 0% 100% 0%)' })
  }

  const sleepMatchTrigerButton = document.getElementById(
    'sleep-match__trigger-btn'
  )
  const sleepMatchTriger = document.getElementById('sleep-match__trigger')
  const sleepMatchService = document.getElementById('sleep-match__service')

  const sleepMatch_tl = gsap
    .timeline({ paused: true, reversed: true })
    .to('.sleep-match__service-image-dark', { opacity: 0, display: 'none' }, 0)
    .to(
      '.sleep-match__service-image-white',
      { opacity: 1, display: 'block' },
      '>'
    )
    .to('.sleep-match__service-content-bottom-dark', { opacity: 0 }, 0)
    .to('.sleep-match__service-content-bottom-white', { opacity: 1 }, 0)
    .to('.sleep-match__service-content-text', { color: '#000000' }, 0)
    .to('.sleep-match__service-content-title', { color: '#000000' }, 0)
    .to('.sleep-match__service-content-logo-svg path', { fill: '#000000' }, 0)
    .to('.sleep-match__service-background', { opacity: 1 }, 0)
    .to('.sleep-match__service-buttons-indicator-one', { opacity: 0 }, 0)
    .to('.sleep-match__service-buttons-indicator-two', { opacity: 1 }, 0)
    .to(
      '#sleep-match__service-button-right',
      { opacity: 0.3, pointerEvents: 'none' },
      0
    )
    .to(
      '#sleep-match__service-button-left',
      { opacity: 1, pointerEvents: 'all' },
      0
    )

  let sleepMatchInterval = null

  const sleepMatchLoop = () => {
    if (sleepMatch_tl.reversed()) {
      sleepMatch_tl.play()
    } else {
      sleepMatch_tl.reverse()
    }
  }

  const createInterval = () => {
    sleepMatchInterval = setInterval(() => {
      sleepMatchLoop()
    }, 10000)
  }

  const moveLeftHandler = () => {
    clearInterval(sleepMatchInterval)
    createInterval()
    sleepMatch_tl.reverse()
  }

  const moveRightHandler = () => {
    clearInterval(sleepMatchInterval)
    createInterval()
    sleepMatch_tl.play()
  }

  const buttonLeft = document.getElementById('sleep-match__service-button-left')
  const buttonRight = document.getElementById(
    'sleep-match__service-button-right'
  )

  buttonLeft.addEventListener('click', moveLeftHandler)
  buttonRight.addEventListener('click', moveRightHandler)

  sleepMatchTrigerButton.addEventListener('click', () => {
    sleepMatchTriger.classList.add('hide')
    sleepMatchService.classList.add('show')
    createInterval()
  })

  heroAnimation()
  factsAnimation()
})
